import type { ApiClient } from '../client';
import { TrackingSearchResponseSchema, type TrackingSearchResponse } from '../schemas/trackingSearch';

// Find the «Entregas» whose tracking matches a term EXACTLY, within the window the server applies.
// The term rides the query string url-encoded; the client attaches the Firebase token via the
// Authorization header, never the URL.
//
// The term arrives ALREADY TRIMMED and is sent verbatim: the 3-character floor is measured on the
// trimmed term by one judge in the care module, and a second trim here would be a second place to
// disagree with the server about what was searched.
//
// Returns the envelope WHOLE. Unlike its siblings that unwrap to bare rows, `count` here is the
// total of matches in the window while the rows are capped, so the two numbers are different facts
// and a caller needs both to say «this list is truncated» instead of lying by omission.
//
// PARSED at the fetch edge since 2026-09-09, which reverses how this read behaved for its first
// day. It shipped casting `client.get<T>` because Zod mirrors what backend DELIVERS and the
// endpoint was still a request — a hand-written total mapper stood in, and a renamed key degraded
// to a modal of em dashes indistinguishable from a backend that had not deployed. What made that
// tolerable was a compensating fact, «the endpoint answers 404 to everything», and backend
// delivering retired it. The schema is what replaces it: the read now fails LOUD, and the hook
// words a rejected read apart from «no matches».
export async function searchDeliveriesByTracking(
  client: ApiClient,
  tracking: string,
): Promise<TrackingSearchResponse> {
  const data = await client.get<unknown>(
    `/app_service/panel/v1/deliveries?tracking=${encodeURIComponent(tracking)}`,
  );
  return TrackingSearchResponseSchema.parse(data);
}
